import { anlagentyp } from './../../../../utils/apiTypes';
import { anlage, umspannwerk } from '../../../../utils/apiTypes';
import { anlageState } from "./anlagenTypes";
import { AnyAction, createSlice, PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { getWithAuth, putWithAuth, deleteWithAuth, postJsonWithAuth } from "../../../../utils/api";
import type { RootState, AppDispatch } from "../../../../app/store";
import { logError } from "../../../../utils/utils";
import { openSnackbar } from "../../../../features/snackbar/globalSnackbarSlice";
import { GridSortModel } from '@material-ui/data-grid';
import { errorHandler } from '../../../../utils/errorHandling';

export const anlageDummy: anlage
  = {
  id: 0,
  name: "",
  beschreibung: "",
  aktiv: false,
  umspannwerk: "",
  anlagentyp: -1,
  kommentar: ""
};

const initialState: anlageState
  = {
  anlageListe: [],
  alteAnlage: anlageDummy,
  aktuelleAnlage: anlageDummy,
  uwList: [],
  anlagentypListe: [],
  newEntry: false,
  editEntry: false,
  editDirty: 0,
  viewMode: false,
  error: [],
  listLoading: false,
  uwLoading: false,
  anlagentypenLoading: false,
  sorting: [
    {
      field: 'name',
      sort: 'asc',
    },
  ]
};

const anlageSlice = createSlice({
  name: "anlage",
  initialState,
  reducers:
  {
    updateAnlageListe: (state, action: PayloadAction<anlage>) => {
      const updateIndex = state.anlageListe.findIndex(
        (x: anlage) => x.id == action.payload.id
      );
      const firstPart = state.anlageListe.slice(0, updateIndex);
      let lastPart = Array<anlage>();
      if (updateIndex + 1 < state.anlageListe.length)
        lastPart = state.anlageListe.slice(updateIndex + 1);
      state.anlageListe = [...firstPart, action.payload, ...lastPart].sort((a, b) => a.name.localeCompare(b.name));
    },
    removeFromAnlageListe: (state, action: PayloadAction<anlage>) => {
      const updateIndex = state.anlageListe.findIndex(
        (x) => x.id == action.payload.id
      );
      const firstPart = state.anlageListe.slice(0, updateIndex);
      let lastPart = Array<anlage>();
      if (updateIndex + 1 < state.anlageListe.length)
        lastPart = state.anlageListe.slice(updateIndex + 1);
      state.anlageListe = [...firstPart, ...lastPart];
    },
    addAktuelleAnlageToAnlageListe: (state) => {
      const anlageArray = state.anlageListe;
      anlageArray.push(state.aktuelleAnlage);
      state.anlageListe = [...anlageArray].sort((a, b) => a.name.localeCompare(b.name));
    },
    setAnlageListe: (state, action: PayloadAction<Array<anlage>>) => {
      state.anlageListe = action.payload;
    },
    setUWs: (state, action: PayloadAction<Array<umspannwerk>>) => {
      state.uwList = action.payload;
    },
    setAnlagentypen: (state, action: PayloadAction<Array<anlagentyp>>) => {
      state.anlagentypListe = action.payload;
    },
    setIdAktuelleAnlage: (state, action: PayloadAction<number>) => {
      state.aktuelleAnlage.id = action.payload;
    },
    setAktuelleAnlage: (state, action: PayloadAction<anlage>) => {
      state.aktuelleAnlage = action.payload;
      state.alteAnlage = action.payload;
    },
    setAlteAnlage: (state, action: PayloadAction<anlage>) => {
      state.alteAnlage = action.payload;
    },
    resetAktuelleAnlage: (state) => {
      state.aktuelleAnlage = state.alteAnlage;
    },
    setEditEntry: (state) => {
      state.editEntry = true;
    },
    resetEditEntry: (state) => {
      state.editEntry = false;
    },
    setNewEntry: (state) => {
      state.newEntry = true;
    },
    resetNewEntry: (state) => {
      state.newEntry = false;
    },
    resetEditDirty: (state) => {
      state.editDirty = 0;
    },
    setViewMode: (state) => {
      state.viewMode = true;
    },
    resetViewMode: (state) => {
      state.viewMode = false;
    },
    setError: (state, action: PayloadAction<string>) => {
      if (!state.error.includes(action.payload)) {
        state.error.push(action.payload);
      }
    },
    resetError: (state, action: PayloadAction<string>) => {
      if (state.error.includes(action.payload)) {
        state.error.splice(state.error.indexOf(action.payload), 1)
      }
    },
    setId: (state, action: PayloadAction<number>) => {
      state.aktuelleAnlage.id = action.payload;
      state.editDirty =
        state.aktuelleAnlage.id ==
          state.alteAnlage.id
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setName: (state, action: PayloadAction<string>) => {
      state.aktuelleAnlage.name = action.payload;
      state.editDirty =
        state.aktuelleAnlage.name ==
          state.alteAnlage.name
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setBeschreibung: (state, action: PayloadAction<string>) => {
      state.aktuelleAnlage.beschreibung = action.payload;
      state.editDirty =
        state.aktuelleAnlage.beschreibung ==
          state.alteAnlage.beschreibung
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setAktiv: (state, action: PayloadAction<boolean>) => {
      state.aktuelleAnlage.aktiv = action.payload;
      state.editDirty =
        state.aktuelleAnlage.aktiv ==
          state.alteAnlage.aktiv
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setUW: (state, action: PayloadAction<string>) => {
      state.aktuelleAnlage.umspannwerk = action.payload;
      state.editDirty =
        state.aktuelleAnlage.umspannwerk ==
          state.alteAnlage.umspannwerk
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setTyp: (state, action: PayloadAction<number>) => {
      state.aktuelleAnlage.anlagentyp = action.payload;
      state.editDirty =
        state.aktuelleAnlage.anlagentyp ==
          state.alteAnlage.anlagentyp
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setKommentar: (state, action: PayloadAction<string>) => {
      state.aktuelleAnlage.kommentar = action.payload;
      state.editDirty =
        state.aktuelleAnlage.kommentar ==
          state.alteAnlage.kommentar
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setListLoading: (state, action: PayloadAction<boolean>) => {
      state.listLoading = action.payload;
    },
    setUmspannwerkLoading: (state, action: PayloadAction<boolean>) => {
      state.uwLoading = action.payload;
    },
    setAnlagentypenLoading: (state, action: PayloadAction<boolean>) => {
      state.anlagentypenLoading = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortModel>) => {
      state.sorting = action.payload;
    },
  }
});


//Selectors
//======================================================================
export const selectAnlageListe = (state: RootState): Array<anlage> =>
  state.anlage.anlageListe;
export const selectUWs = (state: RootState): umspannwerk[] => state.anlage.uwList;
export const selectAnlagentyp = (state: RootState): anlagentyp[] =>
  state.anlage.anlagentypListe;
export const selectAktuelleAnlage = (state: RootState): anlage =>
  state.anlage.aktuelleAnlage;
export const selectEditEntry = (state: RootState): boolean =>
  state.anlage.editEntry;
export const selectNewEntry = (state: RootState): boolean => state.anlage.newEntry;
export const selectEditDirty = (state: RootState): number =>
  state.anlage.editDirty;
export const selectViewMode = (state: RootState): boolean => state.anlage.viewMode;
export const selectError = (state: RootState): boolean => state.anlage.error.length > 0;
export const selectListLoading = (state: RootState): boolean => state.anlage.listLoading;
export const selectUmspannwerkLoading = (state: RootState): boolean => state.anlage.uwLoading;
export const selectAnlagentypentLoading = (state: RootState): boolean => state.anlage.anlagentypenLoading;
export const selectSorting = (state: RootState): GridSortModel => state.anlage.sorting;

//Actions
//=====================================================================

export const getAnlageListe = () => (dispatch: AppDispatch): void => {
  dispatch(setListLoading(true));
  getWithAuth("ANLAGEN", {})
    .then((response) => {
      dispatch(setAnlageListe(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const getUWs = () => (dispatch: AppDispatch): void => {
  dispatch(setUmspannwerkLoading(true));
  getWithAuth("UMSPANNWERK", {})
    .then((response) => {
      dispatch(setUWs(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setUmspannwerkLoading(false)));
};
export const getAnlagentypen = () => (dispatch: AppDispatch): void => {
  dispatch(setAnlagentypenLoading(true));
  getWithAuth("ANLAGENTYPEN", {})
    .then((response) => {
      dispatch(setAnlagentypen(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setAnlagentypenLoading(false)));
};

export const updateAnlage = (aktuelleAnlage: anlage): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  putWithAuth("ANLAGEID", {}, {
    id: aktuelleAnlage.id,
    name: aktuelleAnlage.name,
    beschreibung: aktuelleAnlage.beschreibung,
    aktiv: aktuelleAnlage.aktiv,
    umspannwerk: aktuelleAnlage.umspannwerk,
    anlagentyp: aktuelleAnlage.anlagentyp,
    kommentar: aktuelleAnlage.kommentar
  }, aktuelleAnlage.id.toString())
    .then(() => {
      dispatch(
        openSnackbar({
          message: `Anlage ${aktuelleAnlage.name} wurde erfolgreich geändert.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setAlteAnlage(aktuelleAnlage));
      dispatch(updateAnlageListe(aktuelleAnlage));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const updateAktuelleAnlage = (aktuelleAnlage: anlage): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setAktuelleAnlage(aktuelleAnlage));
  dispatch(setViewMode());
};

export const discardChanges = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuelleAnlage());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
};

export const discardNew = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuelleAnlage());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
  dispatch(resetViewMode());
};

export const startNewEntry = () => (dispatch: AppDispatch): void => {
  dispatch(setNewEntry());
  dispatch(setAktuelleAnlage(anlageDummy));
  dispatch(setEditEntry());
  dispatch(setViewMode());
};

export const createAnlage = (aktuelleAnlage: anlage): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  postJsonWithAuth("ANLAGEN", {}, {
    id: aktuelleAnlage.id,
    name: aktuelleAnlage.name,
    beschreibung: aktuelleAnlage.beschreibung,
    aktiv: aktuelleAnlage.aktiv,
    umspannwerk: aktuelleAnlage.umspannwerk,
    anlagentyp: aktuelleAnlage.anlagentyp,
    kommentar: aktuelleAnlage.kommentar
  })
    .then((response) => {
      dispatch(
        openSnackbar({
          message: `Anlage ${aktuelleAnlage.name} wurde erfolgreich angelegt.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setIdAktuelleAnlage(response));
      dispatch(addAktuelleAnlageToAnlageListe());
      dispatch(setAktuelleAnlage(anlageDummy));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const deleteAnlage = (aktuelleAnlage: anlage): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  deleteWithAuth("ANLAGEID", {}, aktuelleAnlage.id.toString())
    .then(() => {
      dispatch(setAktuelleAnlage(anlageDummy));
      dispatch(removeFromAnlageListe(aktuelleAnlage));
      dispatch(resetEditEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
      dispatch(openSnackbar({
        message: `Anlage ${aktuelleAnlage.name} wurde erfolgreich gelöscht.`,
        severity: "success",
        duration: 6000,
      }));
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const {
  removeFromAnlageListe,
  setAnlageListe,
  setAktuelleAnlage,
  resetAktuelleAnlage,
  setAlteAnlage,
  updateAnlageListe,
  setEditEntry,
  resetEditEntry,
  setNewEntry,
  resetNewEntry,
  resetEditDirty,
  setViewMode,
  resetViewMode,
  setError,
  resetError,
  setName,
  setBeschreibung,
  setTyp,
  setAktiv,
  setUW,
  setId,
  setUWs,
  setKommentar,
  setIdAktuelleAnlage,
  addAktuelleAnlageToAnlageListe,
  setAnlagentypen,
  setListLoading,
  setUmspannwerkLoading,
  setAnlagentypenLoading,
  setSorting
} = anlageSlice.actions;
export default anlageSlice.reducer;